



























import Vue from "vue";
import Component from "vue-class-component";
import PowerBiFrame from "@/components/PowerBiFrame.vue";
import { PowerBiReport } from "@/modules/PowerBi";
import OwnerReportRepository from "@/repositories/report/OwnerReportRepository";
import { Watch } from "vue-property-decorator";
import _ from "lodash";
import {Getter} from "vuex-class";
import { User } from "@/modules/User";
import ChatBot from "@/components/Ai/ChatBot.vue";
import ChatBotMcp from "@/components/Ai/ChatBotMcp.vue";
import {permissions} from "@/Constants";

@Component({
    computed: {
        permissions() {
            return permissions;
        }
    },
    components: {
        ChatBot,
        ChatBotMcp,
        PowerBiFrame,
    },
})

export default class Report extends Vue {
    private metadata: PowerBiReport | null = null;
    private reportId: string | null = null;
    private pageName: string | null = null;

    @Getter("getOwnerReports") public ownerReports!: PowerBiReport[];
    @Getter("getCurrentUser") public currentUser!: User;
    @Getter("hasPermission") public hasPermission!: (permissionName: string) => boolean;

    public mounted() {
        this.retrieveReportId();
        this.retrievePageName();
    }

    @Watch("reportId")
    public reload() {
        this.loadReportMetadata();
    }

    @Watch("ownerReports") public goToDefaultReport() {
        const currentUuid = _.get(this.$route, "query.id", null);
        if (!_.some(this.ownerReports, {uuid: currentUuid})) {
            this.$router.push({name: "redirect"});
        } else {
            this.reportId = currentUuid;
        }
    }

    @Watch("$route.query.id") public retrieveReportId() {
        this.reportId = _.get(this.$route, "query.id", null);
    }

    @Watch("$route.query.pageName") public retrievePageName() {
        this.pageName = _.get(this.$route, "query.pageName", null);
    }

    public loadReportMetadata(): void {
        if (this.reportId) {
            OwnerReportRepository.get({
                filters: { uuid: this.reportId, unique: true },
                fields: ["uuid", "label", "reportUuid", "token", "enabled", "hiddenPages", "userSyncRequired", "agentAiAccess", "agentAiMcpAccess"]
            }).then(
                (data: any) => {
                    if (data.enabled) {
                        this.metadata = data;
                    } else {
                        this.$router.push({name: "owner_report_disabled"});
                    }
                },
                (err: any) => {
                    this.$router.push({name: "owner_report_disabled"});
                }
            );
        } else {
            this.metadata = null;
        }
    }

    public get canDisplayFrame(): boolean {
        return !!this.metadata && !!this.metadata.token && !!this.metadata.reportUuid && !this.displayUserSyncMessage;
    }

    public get displayUserSyncMessage(): boolean {
        return !!this.metadata && !!this.metadata.userSyncRequired && !this.currentUser.isBiSync;
    }

    public async refreshReportToken() {
        if (!this.reportId) {
            return;
        }
        await OwnerReportRepository.get({
            filters: {uuid: this.reportId, unique: true},
            fields: ["token"]
        }).then(
            (data: object[]) => {
                const reports = data as PowerBiReport[];
                const token = _.get(reports, "token", undefined);

                if (this.metadata) {
                    _.set(this.metadata, "token", token);
                }
            },
            (error) => {
                this.$message({
                    type: "error",
                    message: _.invoke(this.$options.filters, "trans", "failedTokenRefresh"),
                });
            }
        );
    }
}
